import React from "react";
import { Form, Input } from "antd";
import { BiMap } from "react-icons/bi";

const BusinessAdressCity = (props) => {
  // -------------------------- VAR --------------------------
  const { disabled } = props;
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- FUNCTION --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  return (
    <Form.Item name="city" label="City" rules={[]}>
      <Input prefix={<BiMap className="form-item-icon" />} placeholder="City" disabled={disabled} />
    </Form.Item>
  );
};

export default BusinessAdressCity;
